import { isEmpty } from 'lodash';
import candidateApi from '~/clientApis/candidateApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { DEFAULT_CANDIDATE } from '~/consts/candidates';
import { getStore } from '~/mobx/AppStore';

export const createCandidate = async () => {
    const candidateStore = getStore().candidateStore;
    const selectedCandidateEdit = candidateStore.selectedCandidateEdit;

    if (isEmpty(candidateStore.selectedRegionId)) {
        return;
    }

    const issuesKeys = candidateStore.validateCandidateForm();
    if (issuesKeys.length) {
        candidateStore.showMessageModalWithFieldKeys(issuesKeys);
        return;
    }

    candidateStore.setIsCreatingCandidate(true);

    try {
        const createdCandidateId = await candidateApi.createCandidate(
            selectedCandidateEdit,
            candidateStore.selectedRegionId
        );
        candidateStore.setSelectedCandidateEdit({
            ...DEFAULT_CANDIDATE,
            id: createdCandidateId,
        });
        await candidateStore.updateCandidatePhoto();
        candidateStore.setIsCreateMode(false);
        candidateStore.getCandidateListByRegionId(candidateStore.selectedRegionId);
    } catch {
        showMessageModal('error', 'Feil under oppretting av kandidat');
    } finally {
        candidateStore.setIsCreatingCandidate(false);
    }
};
